/**
 * Module Name register here
 */
export enum PageName {
  Site = 'Site Management',
  Building = 'Building Management',
  Floor = 'Floor Management',
  Unit = 'Unit Management',
  Users = 'Users',
  UserGroups = 'User Groups',
}

/**
 * Role Name register here
 */
export enum role {
  propertyManagerAdmin = 'PropertyManagerAdmin',
  propertyManagerUser = 'PropertyManagerUser',
  installerAdmin = 'InstallerAdmin',
  installerUser = 'InstallerUser',
  nonTenantUser = 'NonTenantUser',
  tenantAdmin = 'TenantAdmin',
  tenantGuestUser = 'TenantGuestUser',
  eOLTester = 'EOLTester',
  defaultUser = 'DefaultUser',
}

/**
 * Active roles register here
 */
export const activeRoles: role[] = [
  role.propertyManagerAdmin,
  role.propertyManagerUser,
  role.installerAdmin,
];

export interface Page {
  name:
    | PageName.Site
    | PageName.Building
    | PageName.Floor
    | PageName.Unit
    | PageName.Users
    | PageName.UserGroups;
  create: boolean;
  update: boolean;
  view: boolean;
  delete: boolean;
}
export interface UserRoleAccess {
  roleName:
    | role.propertyManagerAdmin
    | role.propertyManagerUser
    | role.installerAdmin
    | role.installerUser
    | role.nonTenantUser
    | role.tenantAdmin
    | role.tenantGuestUser
    | role.eOLTester
    | role.defaultUser;
  pages: Page[];
}

export const UserRoleAccessControl: UserRoleAccess[] = [
  {
    roleName: role.propertyManagerAdmin,
    pages: [
      {
        name: PageName.Site,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
      {
        name: PageName.Building,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
      {
        name: PageName.Floor,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
      {
        name: PageName.Unit,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
      {
        name: PageName.Users,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
      {
        name: PageName.UserGroups,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
    ],
  },
  {
    roleName: role.propertyManagerUser,
    pages: [
      {
        name: PageName.Site,
        create: true,
        update: true,
        view: true,
        delete: false,
      },
      {
        name: PageName.Building,
        create: true,
        update: true,
        view: true,
        delete: false,
      },
      {
        name: PageName.Floor,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
      {
        name: PageName.Unit,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
      {
        name: PageName.Users,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
      {
        name: PageName.UserGroups,
        create: true,
        update: true,
        view: true,
        delete: false,
      },
    ],
  },
  {
    roleName: role.installerAdmin,
    pages: [
      {
        name: PageName.Site,
        create: false,
        update: true,
        view: true,
        delete: false,
      },
      {
        name: PageName.Building,
        create: true,
        update: true,
        view: true,
        delete: false,
      },
      {
        name: PageName.Floor,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
      {
        name: PageName.Unit,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
      {
        name: PageName.Users,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
      {
        name: PageName.UserGroups,
        create: true,
        update: true,
        view: true,
        delete: false,
      },
    ],
  },
  {
    roleName: role.installerUser,
    pages: [
      {
        name: PageName.Site,
        create: false,
        update: false,
        view: false,
        delete: false,
      },
      {
        name: PageName.Building,
        create: false,
        update: false,
        view: false,
        delete: false,
      },
      {
        name: PageName.Floor,
        create: false,
        update: false,
        view: false,
        delete: false,
      },
      {
        name: PageName.Unit,
        create: false,
        update: false,
        view: false,
        delete: false,
      },
      {
        name: PageName.Users,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
      {
        name: PageName.UserGroups,
        create: true,
        update: true,
        view: true,
        delete: false,
      },
    ],
  },
  {
    roleName: role.nonTenantUser,
    pages: [
      {
        name: PageName.Users,
        create: false,
        update: false,
        view: true,
        delete: false,
      },
    ],
  },
  {
    roleName: role.tenantAdmin,
    pages: [
      {
        name: PageName.Users,
        create: false,
        update: false,
        view: true,
        delete: false,
      },
      {
        name: PageName.UserGroups,
        create: true,
        update: true,
        view: true,
        delete: false,
      },
    ],
  },
  {
    roleName: role.tenantGuestUser,
    pages: [
      {
        name: PageName.Users,
        create: false,
        update: false,
        view: true,
        delete: false,
      },
    ],
  },
  {
    roleName: role.eOLTester,
    pages: [
      {
        name: PageName.Users,
        create: false,
        update: false,
        view: true,
        delete: false,
      },
    ],
  },
  {
    roleName: role.defaultUser,
    pages: [
      {
        name: PageName.Site,
        create: false,
        update: false,
        view: false,
        delete: false,
      },
      {
        name: PageName.Building,
        create: false,
        update: false,
        view: false,
        delete: false,
      },
      {
        name: PageName.Floor,
        create: false,
        update: false,
        view: false,
        delete: false,
      },
      {
        name: PageName.Unit,
        create: false,
        update: false,
        view: false,
        delete: false,
      },
      {
        name: PageName.Users,
        create: false,
        update: false,
        view: false,
        delete: false,
      },
      {
        name: PageName.UserGroups,
        create: false,
        update: false,
        view: false,
        delete: false,
      },
    ],
  },
];
